import React, { createElement, useEffect, useState } from "react";
import { ethers } from "ethers";
import { cpCTMTContract, tmCTMTContract } from "./ConAddsAndABIs"
import SellectTFT from "./SellectTFT";

function Managers(){

    const [walletAddress, setWalletAddress] = useState("");
    const [managerId, setManagerId] = useState("");
    const [tokenToTrade, setTokenToTrade] = useState("");
    const [myTokenToTrade, setMyTokenToTrade] = useState("");
    const [myTokenToTradeName, setMyTokenToTradeName] = useState("");
    const [CTMTDepsReceived, setCTMTDepsReceived] = useState("");
    const [baseCTMT, setBaseCTMT] = useState("");
    const [myBUSDBalance, setMyBUSDBalance] = useState("");
    const [myBUSDBalance18Digits, setMyBUSDBalance18Digits] = useState("");
    const [myTFTBalance, setMyTFTBalance] = useState("");
    const [myTFTBalance18Digits, setMyTFTBalance18Digits] = useState("");
    const [myQuotation, setMyQuotation] = useState("");
    const [myTotalBUSDValue, setMyTotalBUSDValue] = useState("");
    const [myUndeclaredSuplusLoss, setMyUndeclaredSuplusLoss] = useState("");
    const [myGrowthValue, setMyGrowthValue] = useState("");
    const [myLocalReserve, setMyLocalReserve] = useState("");
    const [myGlobalReserve, setMyGlobalReserve] = useState("");
    const [myLocalInsurance, setMyLocalInsurance] = useState("");

    const [surplusValue, setSurplusValue] = useState("");
    const [lossValue, setLossValue] = useState("");
    const [sellTFTValue, setSellTFTValue] = useState("");
    const [buyTFTValue, setBuyTFTValue] = useState("");

    const [depositButton, setDepositButton] = useState("");

    let cTFTButton = [];
    const arrTFTId = ['0', '1', '2', '3']
    const arrTFTname = ['btc', 'eth', 'wbnb', 'monsta']
    const arrTFTAddress = ['0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c', '0x2170Ed0880ac9A755fd29B2688956BD959F933F8', 
                           '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c', '0xad6f51E9794d41d3f1755C21DdaB9Fda7387F1e9']

    for (let i=0; i < arrTFTId.length; i++) {
      
      const ata = arrTFTAddress[i]
      const ataF = ata.toString()
      
      const chooseTFT = async (e) => {
        e.preventDefault();
        const txn = await tmCTMTContract.chooseTokenToTrade(ataF)
        await txn.wait();
        }                  
      
      const chooseTFTB = <button onClick={chooseTFT}>Choose</button> 
        cTFTButton.push(chooseTFTB)

      }





    let currentTFTData = []                    
    let tftData = arrTFTId.map((id, index) => {
    const tftObject = {};
      tftObject.id = id;
      tftObject.name = arrTFTname[index];
      tftObject.sellectB = cTFTButton[index];
      tftObject.add = arrTFTAddress[index];

      return tftObject;
    })

    currentTFTData = tftData
     
    const column = [
      {heading: 'Id', value: 'id'},
      {heading: 'Name', value: 'name'},
      {heading: 'Choose', value: 'sellectB'},
      {heading: 'Token Address', value: 'add'},
    ]



    useEffect(() => {  
        
        const getWalletAddress = async () => {
            const accounts = await window.ethereum.request({
                method: "eth_requestAccounts",
            });
            const account = accounts[0]
            const accountF = account.toString()
            setWalletAddress(accountF);
        }
        
        getWalletAddress()
            .catch(console.error)

        const getManagerId = async () => {
          const data = await tmCTMTContract.managerId(walletAddress)
          const dataF = data.toString()
            setManagerId(dataF)
          }
  
        getManagerId()
          .catch(console.error) 

        const getCTMTDepsReceived = async () => {
            const data = await tmCTMTContract.ctmtDeposits(managerId) / (10**18)
            const dataF = data.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                setCTMTDepsReceived(dataF)

            const data1 = await tmCTMTContract.CTMTGrowthBal(managerId) / (10**18)
            const data2 = data + data1
            const data2F = data2.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                setBaseCTMT(data2F)     


            }
    
        getCTMTDepsReceived()
            .catch(console.error)  

        const getMyTokenToTrade = async () => {
          const tft = await tmCTMTContract.manTFT(managerId)
          const tftName = await tmCTMTContract.manTFTName(managerId)
          const str = tft.toString()
            setMyTokenToTrade(str)   
            setMyTokenToTradeName(tftName)       
          }

        getMyTokenToTrade()
          .catch(console.error)  

        const getMyBUSDBalance = async () => {
            const data = await tmCTMTContract.manBUSDBal(managerId)
            const data1 = ethers.utils.formatEther(data)
            const data2 = data / (10**18)
            const dataF1 = data2.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})  
              setMyBUSDBalance(dataF1)  
              setMyBUSDBalance18Digits(data1)
            }
    
        getMyBUSDBalance()
            .catch(console.error)  
            
        const getMyTFTBalance = async () => {
            const data = await tmCTMTContract.manTFTBal(managerId)
            const data1 = ethers.utils.formatEther(data)
            const data2 = await tmCTMTContract.manTFTBal(managerId) / (10**18)
            const dataF1 = data2.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                setMyTFTBalance(dataF1)
                setMyTFTBalance18Digits(data1)
            }
    
        getMyTFTBalance()
            .catch(console.error)  

        const getMyGrowthValue = async () => {
            const data = await tmCTMTContract.CTMTGrowthBal(managerId) / (10**18)
            const commaSeparated = data.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                setMyGrowthValue(commaSeparated)
            }
    
            getMyGrowthValue()
            .catch(console.error)    
            
        const getMyLocalReserve = async () => {
            const balance = await tmCTMTContract.lrCTMTBal(managerId)
            const balanceFormatted = balance / (10**18)
            const commaSeparated = balanceFormatted.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                setMyLocalReserve(commaSeparated)
            }
    
        getMyLocalReserve()
            .catch(console.error)  

        const getMyGlobalReserve = async () => {
            const balance = await tmCTMTContract.checkGlobalReserve(managerId)
            const balanceFormatted = balance / (10**18)
            const commaSeparated = balanceFormatted.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                setMyGlobalReserve(commaSeparated)
            }
    
        getMyGlobalReserve()
            .catch(console.error)  

        const getMyLocalInsurance = async () => {
            const data = await tmCTMTContract.liCTMTBal(managerId) / (10**18)
            const commaSeparated = data.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                setMyLocalInsurance(commaSeparated)
            }
    
        getMyLocalInsurance()
            .catch(console.error)                

     

        const checkTftInBusd = async () => {
          const tftb = await tmCTMTContract.manTFTBal(managerId) / (10**18)
          let busdB = await tmCTMTContract.manBUSDBal(managerId) / (10**18)
          let ctmtD = await tmCTMTContract.ctmtDeposits(managerId) / (10**18)
          let gwt = await tmCTMTContract.CTMTGrowthBal(managerId) / (10**18)
          
          if (tftb === 0) {
            const tftV = 0
            const tav = (tftV + busdB)
            const usl = tav - ctmtD - gwt
            const tftVF = tftV.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) 
            const uslF = usl.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})            
            setMyQuotation(tftVF) 
            setMyTotalBUSDValue(tftVF)
            setMyUndeclaredSuplusLoss(uslF) 
          } else {
            const tftV = await tmCTMTContract.checkBusdValueofTFTBal(managerId) / (10**18)
            const tav = (tftV + busdB)
            const usl = tav - ctmtD - gwt
            const tftVF = tftV.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) 
            const tavF = tav.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
            const uslF = usl.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})            
            setMyQuotation(tftVF) 
            setMyTotalBUSDValue(tavF)
            setMyUndeclaredSuplusLoss(uslF) 
          }}

          checkTftInBusd()
          .catch(console.error)      
          
          const getDepositButton = async () => {
            const data = await cpCTMTContract.isManagerAccDep(walletAddress)

            if (data === true) {
              setDepositButton(<button style={{"width":"150px"}} onClick={handleHoldDepositAcceptance}>Disallow</button >)
            } else if (data === false) {
              setDepositButton(<button style={{"width":"150px"}} onClick={handleContinueDepositAcceptance}>Allow</button>)
            }

                
            }
    
            getDepositButton()
            .catch(console.error)  


        })
    

    const handleDissolve = async (e) => {
        e.preventDefault();
        const txn = await tmCTMTContract.quitMgt()
        await txn.wait();
        }      

    const handleChooseTFTChange = (e) => {
      setTokenToTrade(e.target.value);
        }

    const handleChooseTFTSubmit = async (e) => {
        e.preventDefault();
        console.log(tokenToTrade)
        const txn = await tmCTMTContract.chooseTokenToTrade(tokenToTrade)
        await txn.wait();
        setTokenToTrade(0);
        }

    const handleSellTFTChange = (e) => {
      setSellTFTValue(e.target.value);
    }

    const handleSellTFTSubmit = async (e) => {
      e.preventDefault();
      console.log(sellTFTValue)
      const uintValue = ethers.utils.parseUnits(sellTFTValue, 18)
      const txn = await tmCTMTContract.sellChosenToken(managerId, uintValue, 0)
      await txn.wait();
      setSellTFTValue(0);
    }

    const handleMaxSellTFTChange = async (e) => {
      e.preventDefault();
      console.log(sellTFTValue)
      setSellTFTValue(myTFTBalance18Digits);
    }

    const handleBuyTFTChange = (e) => {
      setBuyTFTValue(e.target.value);
    }

    const handleBuyTFTSubmit = async (e) => {
      e.preventDefault();
      console.log(buyTFTValue)
      const uintValue = ethers.utils.parseUnits(buyTFTValue, 18)
      const txn = await tmCTMTContract.buyChosenToken(uintValue, 0)
      await txn.wait();
      setBuyTFTValue(0);
    }   
    
    const handleMaxBuyTFTChange = async (e) => {
      e.preventDefault();
      console.log(sellTFTValue)
      setBuyTFTValue(myBUSDBalance18Digits);
    }    

    const handleHoldDepositAcceptance = async (e) => {
      e.preventDefault();
      const txn = await cpCTMTContract.changeAcceptDeps()
      await txn.wait();
          }

    const handleContinueDepositAcceptance = async (e) => {
      e.preventDefault();
      const txn = await cpCTMTContract.changeAcceptDeps()
      await txn.wait();
          }

    return(
        <div>
            <div className="row">
              <div className="side">
              <h2 style={{"textAlign": "center"}}>Asset Under My Management</h2><br/>

                <h3 style={{"textAlign": "center"}}>CWJC Supports</h3>
                  <p style={{"textAlign": "center"}}>{depositButton}</p><br/>

                <h3 style={{"textAlign": "center"}}>Trade Assets</h3>
                <form style={{"textAlign": "center"}} onSubmit={handleBuyTFTSubmit}>
                    <input style={{"width": "250px"}} type="number" className="form-control" placeholder="0" onChange={handleBuyTFTChange} value={buyTFTValue} /> <button style={{"width": "100px"}} type={"submit"} className="btn btn-success">Buy {myTokenToTradeName}</button> <button style={{"width": "40px"}} onClick={handleMaxBuyTFTChange}>Max</button>
                    <p>BUSD Balance: {myBUSDBalance18Digits} </p>
                </form><br/> 
                <form style={{"textAlign": "center"}} onSubmit={handleSellTFTSubmit}>
                    <input style={{"width": "250px"}} type="number" className="form-control" placeholder="0" onChange={handleSellTFTChange} value={sellTFTValue} /> <button style={{"width": "100px"}} type={"submit"} className="btn btn-success">Sell {myTokenToTradeName}</button> <button style={{"width": "40px"}} onClick={handleMaxSellTFTChange}>Max</button>
                    <p>{myTokenToTradeName} Balance: {myTFTBalance18Digits} </p>
                </form><br/> 

                <h3 style={{"textAlign": "center"}}>Asset Management Operation</h3>
                <form style={{"textAlign": "center"}} onSubmit={handleSellTFTSubmit}>
                    <button style={{"textAlign": "center"}} type="button" onClick={handleDissolve}>Dissolve</button>
                </form><br/>                 
                                  
              </div>

            <div className="main">
                    <div>
                        <SellectTFT />
                    </div>

            </div>

            </div>

        </div>
        
    )
}

export default Managers;